import { Layout } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { WebengageGeneralButtonEvent, handleClickMetrixEvents } from "containers/services/events.data";
import { useNavigationData } from "./services/cache.data";
import { useAppContext } from "utils/context";
import DefaultHeader from "./components/defaultHeader";
import SideBar from "./components/sidebar";
import FooterWrapper from "./components/footer";

const { Content } = Layout;

const DefaultLayout = () => {
  const { instance, metrixInstance } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const activeMenu = useSelector((state) => state?.routerReducer?.activeMenu);
  const prevMenu = useSelector((state) => state?.routerReducer?.prevMenu);
  const title = useSelector((state) => state?.routerReducer?.title);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { data, isLoading } = useNavigationData(instance);

  const handleAssetMetrix = async (e) => {
    return e.key === "/assets"
      ? await handleClickMetrixEvents(metrixInstance, "user-assets")
      : e.key === "/card" &&
      (await handleClickMetrixEvents(metrixInstance, "card"));
  };

  const handleClickMenu = async (e) => {
    navigate(e.key);
    await handleAssetMetrix(e);
  };

  const handleNavigate = async () => {
    navigate("/fund-orders");
    WebengageGeneralButtonEvent("home-button-orders", prevMenu, "button");
    await handleClickMetrixEvents(metrixInstance, "history");
  };

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderLayoutStyle = () => {
    return !["/profile", "/card"].includes(location.pathname) && "mt-12";
  };

  const isShowDefaultHeader = !["/card"].includes(location.pathname);

  return (
    <Layout className=" items-center bg-white ">
      {isShowDefaultHeader && (
        <DefaultHeader
          handleNavigate={handleNavigate}
          title={title}
          location={location}
        />
      )}

      <Layout className=" w-full max-w-3xl bg-white ">
        <SideBar
          activeMenu={activeMenu}
          handleClickMenu={handleClickMenu}
          windowWidth={windowWidth}
          menuItems={data}
          loading={isLoading}
        />
        <Content
          id="scrollableDiv"
          className={`${renderLayoutStyle()} sm:mt-20 overflow-auto overflow-x-hidden pb-24`}
        >
          <Outlet />
        </Content>
      </Layout>
      <FooterWrapper
        activeMenu={activeMenu}
        handleClickMenu={handleClickMenu}
        menuItems={data}
        windowWidth={windowWidth}
        loading={isLoading}
      />
    </Layout>
  );
};
export default DefaultLayout;
